import ConfirmationDialog from "./confirmationDialog.component";

export default ConfirmationDialog;